import Color from '../Color.mjs'
import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    name: '图片',
    type: 'PIC',
}
